import createReduxForm from '../createReduxForm';
import immutable from '../structure/immutable';

export default createReduxForm(immutable);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/immutable/reduxForm.js
// module id = 1211
// module chunks = 0